export default {"src":"/_next/static/media/mana2u.5a045f51.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};